export const reformatTranslatedMarkup = (body: string) =>
  body
    .replace(/(-\s{1,})/g, "\n$1")
    .replace("```enlace", "```link\n")
    .replace("```jsx", "\n```jsx\n")
    .replace(/```$/, "\n```")
    .replace("] (", "](");
